/**
 * @author zhanhuancheng<zhanhuancheng@ukelink.com>
 * @description 金额辅助
 * @date 2017/05/20
 */
export default class AmountHelper {
    /**
     * @description 数量除以100
     * @param {number} amount 数量
     * @param {number} decimals 小数位数
     * @returns {string}
     * @example
     *     AmountHelper.centiAmount(100) 返回值 1.00
     */
    static centiAmount(amount, decimals = 2) {
        return (parseInt(amount) / 100).toFixed(decimals);
    }


    /**  
     * 精确乘法运算  
     * @param {number} num1 第一个乘数  
     * @param {number} num2 第二个乘数  
     * @returns {number} 精确乘法结果  
     */  
    static multiply(Money, unitArg) {  
        function accMul(arg1, arg2) {  
            let m = 0;  
            const [s1Int, s1Dec] = arg1.toString().split('.');  
            const [s2Int, s2Dec] = arg2.toString().split('.');  
  
            if (s1Dec) m += s1Dec.length;  
            if (s2Dec) m += s2Dec.length;  
  
            return Number(`${s1Int}${s1Dec || ''}`.replace('.', '')) * Number(`${s2Int}${s2Dec || ''}`.replace('.', '')) / Math.pow(10, m);  
        }  
        
        //unitArg为0.01 即为分转元的场景，需要做特殊处理
        if(unitArg < 1 ){
            Money =  parseInt(Money);
        }
  
        return accMul(Money, unitArg);  
    }  

}
